export default __webpack_public_path__ + "static/media/SiteChange.1302d4f6.png";